import React, { useContext, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { Heading2, Heading4 } from '@qover/typography';
import { ZendeskChatContext } from '@qover/contexts';
import { Trans } from '@lingui/react';
// @ts-ignore
import { GlobalLayoutStyles } from '@qover/styles';

import ThankYouBackground from './thankyou.jpg';
import ThankYouBackground2x from './thankyou@2x.jpg';
import Config from '@qover/utils/src/Config';
import { Chat, ChatWrapper, showChat } from '@qover/molecules';
import { Footer, TopBar } from '@qover/organisms';

const InnerContainer = styled.div`
  flex: 1 0 auto;
`;

const PageContainer = styled.div`
  align-items: center;
  display: flex;
  background-image: url(${ThankYouBackground});
  background-size: cover;
  background-repeat: no-repeat;
  justify-content: center;
  min-height: 60vh;
  background-position: top right;
  @media only screen and (-webkit-min-device-pixel-ratio: 2),
    only screen and (min--moz-device-pixel-ratio: 2),
    only screen and (-o-min-device-pixel-ratio: 2/1),
    only screen and (min-device-pixel-ratio: 2),
    only screen and (min-resolution: 192dpi),
    only screen and (min-resolution: 2dppx) {
    background-image: url(${ThankYouBackground2x});
  }
`;

const Card = styled.div`
  background-color: #fff;
  border-radius: ${props => props.theme.borders.cardRadius};
  max-width: 640px;
  padding: 40px;
  margin: 0 20px;
  text-align: center;
  width: 100%;
`;

interface BikeThankYouProps {
  chat?: any;
}

function BikeThankYou(props: BikeThankYouProps) {
  const Chatprops = props.chat;
  const location = useLocation<{ firstName: string }>();
  const history = useHistory();
  const zendeskContext = useContext(ZendeskChatContext);

  useEffect(() => {
    if (!location.state?.firstName) {
      history.push({ ...location, pathname: '/already-qovered' });
    }
  }, []);

  return (
    <>
      <GlobalLayoutStyles />
      {zendeskContext.initializeZendesk && (
        <ChatWrapper
          marginBottom="10px"
          marginRight="10px"
          idBedrockElement="footer-container"
        >
          {props.chat ? <Chatprops /> : <Chat loadChat={Config.loadChat} />}
        </ChatWrapper>
      )}
      <TopBar showChat={showChat} showLanguageSelector />
      <InnerContainer>
        <PageContainer>
          <Card>
            <Heading2 style={{ marginBottom: '10px', marginTop: 0 }}>
              <Trans
                id="bike.thankYou.title"
                values={{ firstName: location.state?.firstName }}
              />
            </Heading2>
            <Heading4 style={{ marginTop: 0, marginBottom: 0 }}>
              <Trans id="bike.thankYou.picturesSent" />
            </Heading4>
          </Card>
        </PageContainer>
      </InnerContainer>
      <Footer />
    </>
  );
}

export default BikeThankYou;
